import { Reducer } from 'redux'
import { ActionTypes, QUESTIONNAIRE_ACTIONS, Question, STEPS } from './types'

const initialState: State = {
  currentStep: null,
  questions: [],
  currentQuestionIndex: 0,
  assessmentId: null,
  isSubmitting: false,
}

type State = {
  currentStep: STEPS | null
  questions: Question[]
  currentQuestionIndex: number
  assessmentId: number | null
  isSubmitting: boolean
}

export const questionnaire: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case QUESTIONNAIRE_ACTIONS.SET_CURRENT_STEP: {
      return {
        ...state,
        currentStep: action.currentStep,
      }
    }

    case QUESTIONNAIRE_ACTIONS.SET_QUESTIONS: {
      return {
        ...state,
        assessmentId: action.assessmentId,
        questions: action.questions,
      }
    }

    case QUESTIONNAIRE_ACTIONS.SELECT_OPTION: {
      const { questionId, optionId } = action.payload
      const updatedQuestions = state.questions.map(question => {
        if (question.id === questionId) {
          return {
            ...question,
            selectedOptionId: optionId,
          }
        }
        return question
      })

      return {
        ...state,
        questions: updatedQuestions,
      }
    }

    case QUESTIONNAIRE_ACTIONS.NEXT_QUESTION: {
      const nextQuestion = state.currentQuestionIndex + 1

      if (nextQuestion >= state.questions.length) {
        return state
      }

      return {
        ...state,
        currentQuestionIndex: nextQuestion,
      }
    }

    case QUESTIONNAIRE_ACTIONS.PREVIOUS_QUESTION: {
      const previousQuestion = state.currentQuestionIndex - 1

      if (previousQuestion < 0) throw new Error('No previous question available')

      return {
        ...state,
        currentQuestionIndex: previousQuestion,
      }
    }

    case QUESTIONNAIRE_ACTIONS.SET_IS_SUBMITTING: {
      return {
        ...state,
        isSubmitting: action.isSubmitting,
      }
    }

    case QUESTIONNAIRE_ACTIONS.CLEAR_QUESTIONS: {
      return {
        ...state,
        questions: [],
        currentQuestionIndex: 0,
        assessmentId: null,
      }
    }

    default:
      return state
  }
}
